export const removeQueryParams = (url) => {
  try {
    const urlObject = new URL(url);
    urlObject.search = '';
    return urlObject.toString();
  } catch {
    return url;
  }
};
